module.exports = __webpack_public_path__ + "img/order.1c3ea7c.png";